module.exports = __webpack_public_path__ + "static/media/send-back.9403f0d9.svg";